<div class="pt-10">
    @if(!authenticated){
    <app-validation-code ($validationSuccess)="onValidationSuccess($event)"></app-validation-code>
    }
    @else if(editingEntity() == null || editingEntity() == undefined){
    <p>Aucune activité trouvée</p>
    }
    @else if(!sucessUploaded){
    <app-upload-document (filesChanged)="onFilesChanged($event)"></app-upload-document>
    <div class="p-0 bg-white shadow-md mt-6">
        <button type="button" (click)="onUploadFiles()"
            [disabled]="files.length === 0"
            class="w-full bg-blue-500 text-white rounded-lg p-2 font-bold text-lg shadow-lg hover:bg-blue-700 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none">
            <i class="fa-solid fa-download text-blue-100 text-3xl -ml-[13%] mr-[6%]"></i>
            {{ 'buttons.upload-documents' | translate }}
        </button>
    </div>
    }
    @if(sucessUploaded){
    <div class="text-gray-100 p-4 border border-green-900 rounded bg-green-500 text-center mt-4 text-2xl">
        <i class="fa-solid fa-face-smile text-xl ml-2"></i>
        {{ 'vues.qr-code.upload-document.success' | translate }}
    </div>
    }
</div>